import React, {Component, createRef} from 'react'
import styles from './FJTimeHandler.module.less'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import multiSvg from 'fj-components/icon/multi.svg';
import InlineSVG from "react-inlinesvg";
import {FJPreviewAction, FJTimeLineAction} from "../../../redux/action/FJRoot.action";
import {connect} from "react-redux";
import FJTimelineStore from "fj-timeline";

class FJTimeHandler extends Component {

  constructor(props) {
    super(props);
    this.line = createRef();
  }

  componentDidMount() {
    // todo
    // window.FJEvent.subscribe('TRIGGER_AUTO_EDGE_SCROLL', ({cursorPoint, horizontal, vertical, callback}) => {
    //   this.triggerEdgeScroll(cursorPoint, horizontal, vertical, callback);
    // });
  }

  /**
   * @description 返回进度线的DOMRect
   * @return {DOMRect}
   */
  getProcessLineRect = () => {
    return this.line.current.getBoundingClientRect();
  };

  render() {
    let {
      isDragging,
      scrollLeft,
      contentWidth,
      isPlaying,
      classes,
      currentTime
    } = this.props;

    // 更新超过限制的置灰
    let currentLeft = currentTime * FJTimelineStore.getUnitConversion() > contentWidth - 16 ? contentWidth - 16 : currentTime * FJTimelineStore.getUnitConversion();
    currentLeft = currentLeft - scrollLeft;
    currentLeft = isDragging ? currentLeft < 0 ? 0 : currentLeft : currentLeft;

    let handleCls = classNames(styles.handle, classes.handleClassName);
    let lineCls = classNames(styles.line, classes.lineClassName);

    return (
        <div ref={this.line}
             style={{transform: `translateX(${currentLeft}px)`}}
             className={classNames(styles.handle_container, {[styles.idle_now]: !(isPlaying || isDragging)})}>
          <div data-process-line='' className={lineCls}/>
          <div className={handleCls}>
            <InlineSVG src={multiSvg} className={styles.svg_icon}/>
          </div>
        </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement
FJTimeHandler.propTypes = {
  classes: PropTypes.object
};

// eslint-disable-next-line react/static-property-placement
FJTimeHandler.defaultProps = {
  classes: {
    handleClassName: '',
    lineClassName: ''
  }
};

const mapStateToProps = function (state) {
  return {
    isPlaying: state.preview.isPlaying,
    duration: state.timeline.duration,
    currentTime: state.timeline.currentTime
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
  }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJTimeHandler);
